import React from "react";
import { Container, Card, Button, Badge } from "react-bootstrap";
import Logo from "../../assets/Images/logo.png";
import WebService from "../../Services/WebService";
import { BsTools, BsBoxArrowRight, BsArrowClockwise, BsShieldCheck } from "react-icons/bs";

const RmUnderDevelopment: React.FC = () => {
  const handleLogout = () => {
    WebService.logout();
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div
      className="min-vh-100 d-flex flex-column justify-content-between"
      style={{
        background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
        color: "#1e293b",
      }}
    >
      {/* Top Header */}
      <header
        className="py-3 px-4 shadow-sm d-flex justify-content-between align-items-center"
        style={{ background: "#ffffff", borderBottom: "1px solid #e2e8f0" }}
      >
        <div className="d-flex align-items-center gap-3">
          <img src={Logo} alt="Prime Shark Logo" width={130} />
          <Badge
            bg="primary"
            className="px-2.5 py-1.5 rounded-pill font-12 fw-semibold"
            style={{ letterSpacing: "0.5px" }}
          >
            RM PORTAL
          </Badge>
        </div>
        <Button
          variant="outline-danger"
          size="sm"
          className="d-flex align-items-center gap-2 px-3 py-2 rounded-pill font-14 fw-semibold"
          onClick={handleLogout}
        >
          <BsBoxArrowRight size={16} /> Logout
        </Button>
      </header>

      {/* Main Content */}
      <Container className="d-flex justify-content-center align-items-center flex-grow-1 py-5">
        <Card
          className="border-0 shadow-lg text-center p-4 p-md-5"
          style={{
            maxWidth: "580px",
            width: "100%",
            borderRadius: "24px",
            background: "#ffffff",
            boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.04)",
          }}
        >
          {/* Animated/Glowing Icon */}
          <div className="mb-4 d-flex justify-content-center">
            <div
              className="d-flex justify-content-center align-items-center rounded-circle"
              style={{
                width: "90px",
                height: "90px",
                background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
                color: "#2563eb",
                boxShadow: "0 10px 15px -3px rgba(37, 99, 235, 0.2)",
              }}
            >
              <BsTools size={42} />
            </div>
          </div>

          <div className="mb-3">
            <Badge
              bg="warning"
              text="dark"
              className="px-3 py-1.5 rounded-pill font-12 fw-bold mb-2 text-uppercase"
              style={{ letterSpacing: "1px" }}
            >
              UNDER DEVELOPMENT
            </Badge>
            <h2 className="fw-bold font-28 mb-2" style={{ color: "#0f172a" }}>
              Relationship Manager Portal
            </h2>
            <p className="text-muted font-15 mb-4" style={{ lineHeight: "1.6" }}>
              The Relationship Manager Portal is currently under development to bring you an improved experience.
              Please check back soon.
            </p>
          </div>

          {/* Info Card */}
          <div
            className="p-3 mb-4 rounded-3 text-start d-flex align-items-center gap-3"
            style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}
          >
            <div className="text-primary fs-4">
              <BsShieldCheck />
            </div>
            <div>
              <div className="fw-semibold font-14" style={{ color: "#334155" }}>
                Scheduled Development
              </div>
              <div className="text-muted font-12">
                If you believe this is an error, please contact your system administrator.
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
            <Button
              variant="primary"
              className="px-4 py-2.5 rounded-pill font-14 fw-semibold d-flex align-items-center justify-content-center gap-2"
              onClick={handleRefresh}
            >
              <BsArrowClockwise size={16} /> Refresh Page
            </Button>
            <Button
              variant="outline-secondary"
              className="px-4 py-2.5 rounded-pill font-14 fw-semibold d-flex align-items-center justify-content-center gap-2"
              onClick={handleLogout}
            >
              <BsBoxArrowRight size={16} /> Back to Login
            </Button>
          </div>
        </Card>
      </Container>

      {/* Footer */}
      <footer className="py-3 text-center text-muted font-13">
        © {new Date().getFullYear()} Prime Shark Admin. All rights reserved.
      </footer>
    </div>
  );
};

export default RmUnderDevelopment;
